import React, { useEffect, useState } from "react";
import { getRequest } from "../../service";
import { getEmployeeId } from "../../utils/localStorage";
import { Spin } from "antd";

const LeaveTable = () => {
  const [leaveConfigs, setLeaveConfigs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLeaves = async () => {
      setLoading(true);
      try {
        const employeeId = getEmployeeId();
        if (!employeeId) {
          setLeaveConfigs([]);
          setLoading(false);
          return;
        }
        const res = await getRequest(`/api/leaves/byEmployee?employeeId=${employeeId}`);
        setLeaveConfigs(res?.leaveConfigs || []);
      } catch (err) {
        setLeaveConfigs([]);
      } finally {
        setLoading(false);
      }
    };
    fetchLeaves();
  }, []);

  return (
    <Spin spinning={loading} size="large">
      <table className="min-w-full bg-white ">
        <thead>
          <tr className="text-left border-b border-gray-200">
            <th className="px-4 py-2 text-[14px] font-semibold text-primary">
              Title
            </th>
            <th className="px-4 py-2 text-[14px] font-semibold text-primary text-right">
              Balance
            </th>
          </tr>
        </thead>
        <tbody>
          {leaveConfigs.length === 0 ? (
            <tr>
              <td colSpan={2} className="px-4 py-4 text-center text-gray-500">
                No leave data found.
              </td>
            </tr>
          ) : (
            leaveConfigs.map((leave) => (
              <tr className="border-b border-gray-200" key={leave._id}>
                <td className="px-4 py-2 text-[14px] text-gray-700">
                  {leave.title}
                </td>
                <td className="px-4 py-2 text-[14px] text-primary text-right">
                  {leave.used ?? 0}/{leave.totalAllowed ?? leave.numberOfDays ?? 0}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </Spin>
  );
};

export default LeaveTable;
